// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Project } from '@/project/api/types';
import { Typography, TypographyProps } from '@mui/material';

/** Project fields rendered and edited in the key dates section */
export type ProjectKeyDateField =
  | 'contractSignedOn'
  | 'siteVisitDate'
  | 'installDate'
  | 'trainingDate'
  | 'goLiveDate'
  | 'acceptanceDate';

interface Props extends Pick<TypographyProps, 'variant' | 'whiteSpace'> {
  project: Pick<Project, ProjectKeyDateField>;
  field: ProjectKeyDateField;
}

export function ProjectKeyDateLabel(props: Props) {
  const date = props.project[props.field];

  if (date) {
    return (
      <Typography variant={props.variant} whiteSpace={props.whiteSpace}>
        {date.toLocaleString({ dateStyle: 'medium' })}
      </Typography>
    );
  }

  return (
    <Typography
      variant={props.variant}
      whiteSpace={props.whiteSpace}
      color="text.secondary"
    >
      Not set
    </Typography>
  );
}
